import React from "react"
import "./DisplayDataContainer.scss"
import {useSelector} from "react-redux"
import _ from "lodash"
import DisplayDataTable from "./DisplayDataTable"

import {
    getDisplayDataColumns,
    getDisplayDemographics,
    getGenerateTable,
} from "../redux/refdb.selector"
import DisplayDemographicPanel from "./DisplayDemographicPanel"
import GenerateTableType from "../../shared/enums/generateTableType"

const RefDbPanel = (): JSX.Element => {
    const columns = useSelector(getDisplayDataColumns)
    const demographics = useSelector(getDisplayDemographics)
    const tableType = useSelector(getGenerateTable)

    if (columns.length === 0 && _.isEmpty(demographics)) {
        return (
            <div
                style={{
                    textAlign: "center",
                    paddingTop: "50vh",
                }}
            >
                {/* {t( */}
                {/*    "Please select matrix using the Select your matrix dialog." */}
                {/* )} */}
            </div>
        )
    }

    return tableType === GenerateTableType.demographic ? (
        <DisplayDemographicPanel />
    ) : (
        <DisplayDataTable />
    )
}

export default RefDbPanel
